import { LoggerConfig, LogLevel } from "@core/logger";
import { CommonModalConfig } from "@common/modal";
import { ChartConfig } from "@widget/chart";

export const DEFAULT_CONFIG_LOGGER: LoggerConfig = { logLevel: LogLevel.DEBUG, serverLogLevel: LogLevel.OFF, apiEndpoint: '/logger/log', authToken: localStorage.getItem('accessToken') || 'NOT_SET' };

export const DEFAULT_CONFIG_CHART_WIDGET: ChartConfig = {
  logConfig: DEFAULT_CONFIG_LOGGER,
  styleConfig: { styleName: 'STYLE_1', themeType: 'LIGHT' },
  instanceConfig: { eventId: 'DEFAULT_EVENT_CHART_WIDGET', instanceId: 'DEFAULT_INSTANCE_CHART_WIDGET' }
};

export const DEFAULT_CONFIG_STATUS_MODAL: CommonModalConfig = {
  logConfig: DEFAULT_CONFIG_LOGGER,
  styleConfig: { styleName: 'STYLE_1', themeType: 'LIGHT' },
  instanceConfig: { eventId: 'DEFAULT_EVENT_CHART_WIDGET', instanceId: 'DEFAULT_INSTANCE_CHART_WIDGET' }
}
